/** IMPORTS */
import {IWall} from '../models/wall';
import {IPost} from '../models/post';
import {IComment} from '../models/comment';
import { User } from '../models/user';
import {ITag} from '../models/tag';
import { IAlert } from '../models/alert';

/** ACTIONS */
export const SIGNIN = 'SIGNIN';
export const SIGNIN_SUCCESS = 'SIGNIN_SUCCESS';
export const SIGNIN_ERROR = 'SIGNIN_ERROR';
export const AUTH_STATUS = 'AUTH_STATUS';
export const MSSIGNIN = 'MSSIGNIN';
export const MSSIGNIN_SUCCESS = 'MSSIGNIN_SUCCESS';
export const MSSIGNIN_ERROR = 'SIGNIN_ERROR';
export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_ERROR = 'LOGOUT_ERROR';
export const ADD_WALL = 'ADD_WALL';
export const ADD_WALL_SUCCESS = 'ADD_WALL_SUCCESS';
export const ADD_WALL_ERROR = 'ADD_WALL_ERROR';
export const ADD_POST = 'ADD_POST';
export const ADD_POST_SUCCESS = 'ADD_POST_SUCCESS';
export const ADD_POST_ERROR = 'ADD_POST_ERROR';
export const ADD_COMMENT = 'ADD_COMMENT';
export const ADD_COMMENT_SUCCESS = 'ADD_COMMENT_SUCCESS';
export const ADD_COMMENT_ERROR = 'ADD_COMMENT_ERROR';
export const ADD_TAG = 'ADD_TAG';
export const ADD_TAG_SUCCESS = 'ADD_TAG_SUCCESS';
export const ADD_TAG_ERROR = 'ADD_TAG_ERROR';
export const UPDATE_WALL = 'UPDATE_WALL';
export const UPDATE_WALL_SUCCESS = 'UPDATE_WALL_SUCCESS';
export const UPDATE_WALL_ERROR = 'UPDATE_WALL_ERROR';
export const UPDATE_POST = 'UPDATE_POST';
export const UPDATE_POST_SUCCESS = 'UPDATE_POST_SUCCESS';
export const UPDATE_POST_ERROR = 'UPDATE_POST_ERROR';
export const UPDATE_COMMENT = 'UPDATE_COMMENT';
export const UPDATE_COMMENT_SUCCESS = 'UPDATE_COMMENT_SUCCESS';
export const UPDATE_COMMENT_ERROR = 'UPDATE_COMMENT_ERROR';
export const UPDATE_TAG = 'UPDATE_TAG';
export const UPDATE_TAG_SUCCESS = 'UPDATE_TAG_SUCCESS';
export const UPDATE_TAG_ERROR = 'UPDATE_TAG_ERROR';
export const REMOVE_WALL = 'REMOVE_WALL';
export const REMOVE_WALL_SUCCESS = 'REMOVE_WALL_SUCCESS';
export const REMOVE_WALL_ERROR = 'REMOVE_WALL_ERROR';
export const REMOVE_POST = 'REMOVE_POST';
export const REMOVE_POST_SUCCESS = 'REMOVE_POST_SUCCESS';
export const REMOVE_POST_ERROR = 'REMOVE_POST_ERROR';
export const REMOVE_COMMENT = 'REMOVE_COMMENT';
export const REMOVE_COMMENT_SUCCESS = 'REMOVE_COMMENT_SUCCESS';
export const REMOVE_COMMENT_ERROR = 'REMOVE_COMMENT_ERROR';
export const REMOVE_TAG = 'REMOVE_TAG';
export const REMOVE_TAG_SUCCESS = 'REMOVE_TAG_SUCCESS';
export const REMOVE_TAG_ERROR = 'REMOVE_TAG_ERROR';
export const REQUEST_WALL = 'REQUEST_WALL';
export const REQUEST_WALL_SUCCESS = 'REQUEST_WALL_SUCCESS';
export const REQUEST_WALL_ERROR = 'REQUEST_WALL_ERROR';
export const REQUEST_WALLS = 'REQUEST_WALLS';
export const REQUEST_WALLS_ADMIN = 'REQUEST_WALLS_ADMIN';
export const REQUEST_WALLS_SUCCESS = 'REQUEST_WALLS_SUCCESS';
export const REQUEST_WALLS_ERROR = 'REQUEST_WALL_ERROR';
export const REQUEST_POST = 'REQUEST_POST';
export const REQUEST_POST_SUCCESS = 'REQUEST_POST_SUCCESS';
export const REQUEST_POST_ERROR = 'REQUEST_POST_ERROR';
export const REQUEST_POSTS = 'REQUEST_POSTS';
export const REQUEST_POSTS_SUCCESS = 'REQUEST_POSTS_SUCCESS';
export const REQUEST_POSTS_ERROR = 'REQUEST_POSTS_ERROR';
export const REQUEST_COMMENT = 'REQUEST_COMMENT';
export const REQUEST_COMMENT_SUCCESS = 'REQUEST_COMMENT_SUCCESS';
export const REQUEST_COMMENT_ERROR = 'REQUEST_COMMENT_ERROR';
export const REQUEST_COMMENTS = 'REQUEST_COMMENTS';
export const REQUEST_COMMENTS_SUCCESS = 'REQUEST_COMMENTS_SUCCESS';
export const REQUEST_COMMENTS_ERROR = 'REQUEST_COMMENTS_ERROR';
export const REQUEST_TAG = 'REQUEST_TAG';
export const REQUEST_TAG_SUCCESS = 'REQUEST_TAG_SUCCESS';
export const REQUEST_TAG_ERROR = 'REQUEST_TAG_ERROR';
export const REQUEST_TAGS = 'REQUEST_TAGS';
export const REQUEST_TAGS_SUCCESS = 'REQUEST_TAGS_SUCCESS';
export const REQUEST_TAGS_ERROR = 'REQUEST_TAGS_ERROR';
export const TOKEN_REQUEST = 'TOKEN_REQUEST';
export const TOKEN_REQUEST_SUCCESS = 'TOKEN_REQUEST_SUCCESS';
export const TOKEN_REQUEST_ERROR = 'TOKEN_REQUEST_ERROR';
export const TOKEN_SET_SUCCESS = 'TOKEN_SET_SUCCESS';
export const UPDATE_LIKE = 'UPDATE_LIKE';
export const UPDATE_LIKE_SUCCESS = 'UPDATE_LIKE_SUCCESS';
export const UPDATE_LIKE_ERROR = 'UPDATE_LIKE_ERROR';
export const UPDATE_LIKE_COUNT = 'UPDATE_LIKE_COUNT';
export const UPDATE_LIKE_COUNT_SUCCESS = 'UPDATE_LIKE_COUNT_SUCCESS';
export const UPDATE_LIKE_COUNT_ERROR = 'UPDATE_LIKE_COUNT_ERROR';
export const UPDATE_FEATUREDPOST = 'UPDATE_FEATUREDPOST';
export const UPDATE_FEATUREDPOST_SUCCESS = 'UPDATE_FEATUREDPOST_SUCCESS';
export const UPDATE_FEATUREDPOST_ERROR = 'UPDATE_FEATUREDPOST_ERROR';
export const REQUEST_POSTFEATURED = 'REQUEST_POSTFEATURED';
export const REQUEST_POSTFEATURED_SUCCESS = 'REQUEST_POSTFEATURED_SUCCESS';
export const REQUEST_POSTFEATURED_ERROR = 'REQUEST_POSTFEATURED_ERROR';
export const UPDATE_FEATURED_ORDER = 'UPDATE_FEATURED_ORDER';
export const UPDATE_FEATURED_ORDER_SUCCESS = 'UPDATE_FEATURED_ORDER_SUCCESS';
export const UPDATE_FEATURED_ORDER_ERROR = 'UPDATE_FEATURED_ORDER_ERROR';
export const REQUEST_ALERT = 'REQUEST_ALERT';
export const REQUEST_ALERT_SUCCESS = 'REQUEST_ALERT_SUCCESS';
export const REQUEST_ALERT_ERROR = 'REQUEST_ALERT_ERROR';
export const UPDATE_ALERT = 'UPDATE_ALERT';
export const UPDATE_ALERT_SUCCESS = 'UPDATE_ALERT_SUCCESS';
export const UPDATE_ALERT_ERROR = 'UPDATE_ALERT_ERROR';
export const ADD_ALERT = 'ADD_ALERT';
export const ADD_ALERT_SUCCESS = 'ADD_ALERT_SUCCESS';
export const ADD_ALERT_ERROR = 'ADD_ALERT_ERROR';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const REMOVE_ALERT_SUCCESS = 'REMOVE_ALERT_SUCCESS';
export const REMOVE_ALERT_ERROR = 'REMOVE_ALERT_ERROR';
export const REQUEST_ALERTS = 'REQUEST_ALERTS';
export const REQUEST_ALERTS_SUCCESS = 'REQUEST_ALERTS_SUCCESS';
export const REQUEST_ALERTS_ERROR = 'REQUEST_ALERTS_ERROR';
export const CHECK_PENDING_POSTS = 'CHECK_PENDING_POSTS';
export const CHECK_PENDING_POSTS_SUCCESS = 'CHECK_PENDING_POSTS_SUCCESS';
export const CHECK_PENDING_POSTS_ERROR = 'CHECK_PENDING_POSTS_ERROR';
export const POSTS_REORDER = 'POSTS_REORDER';
export const POSTS_REORDER_SUCCESS = 'POSTS_REORDER_SUCCESS';

/** Users */
export const REQUEST_USERS = 'REQUEST_USERS';
export const REQUEST_USERS_SUCCESS = 'REQUEST_USERS_SUCCESS';
export const REQUEST_USERS_ERROR = 'REQUEST_USERS_ERROR';
export const ADD_USER = 'ADD_USER';
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const ADD_USER_ERROR = 'ADD_USER_ERROR';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';
export const REMOVE_USER = 'REMOVE_USER';
export const REMOVE_USER_SUCCESS = 'REMOVE_USER_SUCCESS';
export const REMOVE_USER_ERROR = 'REMOVE_USER_ERROR';
export const AUTHORIZE_USER = 'AUTHORIZE_USER';
export const AUTHORIZE_USER_SUCCESS = 'AUTHORIZE_USER_SUCCESS';
export const AUTHORIZE_USER_ERROR = 'AUTHORIZE_USER_ERROR';
export const DEAUTHORIZE_USER = 'DEAUTHORIZE_USER';
export const DEAUTHORIZE_USER_SUCCESS = 'DEAUTHORIZE_USER_SUCCESS';
export const DEAUTHORIZE_USER_ERROR = 'DEAUTHORIZE_USER_ERROR';

/** Keys */
export const REQUEST_KEYS = 'REQUEST_KEYS';
export const REQUEST_KEYS_SUCCESS = 'REQUEST_KEYS_SUCCESS';
export const REQUEST_KEYS_ERROR = 'REQUEST_KEYS_ERROR';
export const ADD_KEY = 'ADD_KEY';
export const ADD_KEY_SUCCESS = 'ADD_KEY_SUCCESS';
export const ADD_KEY_ERROR = 'ADD_KEY_ERROR';
export const UPDATE_KEY = 'UPDATE_KEY';
export const UPDATE_KEY_SUCCESS = 'UPDATE_KEY_SUCCESS';
export const UPDATE_KEY_ERROR = 'UPDATE_KEY_ERROR';
export const REMOVE_KEY = 'REMOVE_KEY';
export const REMOVE_KEY_SUCCESS = 'REMOVE_KEY_SUCCESS';
export const REMOVE_KEY_ERROR = 'REMOVE_KEY_ERROR';

/** HANDLERS */
export const signInSuccess = (user:User) => ({type: SIGNIN_SUCCESS, payload:user}); 
export const signInError = () => ({type: SIGNIN_ERROR, payload:{error:true}}); 
export const logOutSuccess = () => ({type: LOGOUT_SUCCESS, payload: {token: '', session:false}}); 
export const logOutError = () => ({type: LOGOUT_ERROR}); 
export const setUser = (user:User) => ({type:SIGNIN_SUCCESS, payload:user});
export const tokenSuccess = (token:string) => ({type: TOKEN_REQUEST_SUCCESS, payload:{token}}); 
export const tokenError = () => ({type: TOKEN_REQUEST_ERROR}); 
export const setToken = (token:string) => ({type: TOKEN_SET_SUCCESS, payload:{user:{token: token}}});

/** USERS */
export const setUsersSuccess = (users:any) => ({type: REQUEST_USERS_SUCCESS, payload: users});
export const setUsersError = () => ({type: REQUEST_USERS_ERROR});
export const addUserSuccess = (user:any) => ({type: ADD_USER_SUCCESS, payload: user});
export const addUserError = () => ({type: ADD_USER_ERROR});
export const updateUserSuccess = (user:any) => ({type: UPDATE_USER_SUCCESS, payload: user});
export const updateUserError = () => ({type: UPDATE_USER_ERROR});
export const removeUserSuccess = (id:string) => ({type: REMOVE_USER_SUCCESS, payload: id });
export const removeUserError = () => ({type: REMOVE_USER_ERROR});
export const authorizeUserSuccess = () => ({type: AUTHORIZE_USER_SUCCESS});
export const authorizeUserError = () => ({type: AUTHORIZE_USER_ERROR});
export const deauthorizeUserSuccess = (user:any) => ({type: UPDATE_USER_SUCCESS, payload: user});
export const deauthorizeUserError = () => ({type: DEAUTHORIZE_USER_ERROR});


/** WALLS */
export const addWallSuccess = (wall:IWall) => ({type: ADD_WALL_SUCCESS, payload:wall}); 
export const addWallError = () => ({type: ADD_WALL_ERROR}); 
export const updateWallSuccess = (wall:IWall) => ({type: UPDATE_WALL_SUCCESS, payload:wall}); 
export const updateWallError = () => ({type: UPDATE_WALL_ERROR}); 
export const removeWallSuccess = (id:string) => ({type: REMOVE_WALL_SUCCESS, payload:id}); 
export const removeWallError = () => ({type: REMOVE_WALL_ERROR}); 
export const getWallSuccess = (wall:IWall) => ({type: REQUEST_WALL_SUCCESS, payload: {wall}}); 
export const getWallError = () => ({type: REQUEST_WALL_ERROR});
export const getWallsSuccess = (walls:any) => ({type: REQUEST_WALLS_SUCCESS, payload: walls}); 
export const getWallsError = () => ({type: REQUEST_WALLS_ERROR});
export const updateFeaturedPostOrderSuccess = (wall:IWall) => ({type: UPDATE_FEATURED_ORDER_SUCCESS, payload:wall}); 
export const updateFeaturedPostOrderError = () => ({type: UPDATE_FEATURED_ORDER_ERROR});

/** POSTS */
export const addPostSuccess = (post:IPost) => ({type: ADD_POST_SUCCESS, payload:post}); 
export const addPostError = () => ({type: ADD_POST_ERROR}); 
export const updatePostSuccess = (post:IPost) => ({type: UPDATE_POST_SUCCESS, payload:post}); 
export const updatePostError = () => ({type: UPDATE_POST_ERROR}); 
export const removePostSuccess = (id:string) => ({type: REMOVE_POST_SUCCESS, payload:id}); 
export const removePostError = () => ({type: REMOVE_POST_ERROR}); 
export const getPostSuccess = (post:IPost) => ({type: REQUEST_POST_SUCCESS, payload: post}); 
export const getPostError = () => ({type: REQUEST_POST_ERROR});
export const getPostsSuccess = (posts:any) => ({type: REQUEST_POSTS_SUCCESS, payload: posts}); 
export const getPostsError = () => ({type: REQUEST_POSTS_ERROR});
export const updateFeaturedPostSuccess = (wall:IWall) => ({type: UPDATE_FEATUREDPOST_SUCCESS, payload: wall});
export const updateFeaturedPostError = () => ({type: UPDATE_FEATUREDPOST_ERROR});
export const getPostFeaturedSuccess = (post:IPost) => ({type: REQUEST_POSTFEATURED_SUCCESS, payload: post}); 
export const getPostFeaturedError = () => ({type: REQUEST_POSTFEATURED_ERROR});
export const reorderPostsSuccess = (posts:any) => ({type: POSTS_REORDER_SUCCESS, payload:posts});

/** COMMENTS */
export const addCommentSuccess = (comment:IComment) => ({type: ADD_COMMENT_SUCCESS, payload:comment}); 
export const addCommentError = () => ({type: ADD_COMMENT_ERROR}); 
export const updateCommentSuccess = (comment:IComment) => ({type: UPDATE_COMMENT_SUCCESS, payload:comment}); 
export const updateCommentError = () => ({type: UPDATE_COMMENT_ERROR}); 
export const removeCommentSuccess = (id:string) => ({type: REMOVE_COMMENT_SUCCESS, payload:id}); 
export const removeCommentError = () => ({type: REMOVE_COMMENT_ERROR}); 
export const getCommentSuccess = (comment:IComment) => ({type: REQUEST_COMMENT_SUCCESS, payload: {comment}}); 
export const getCommentError = () => ({type: REQUEST_COMMENT_ERROR});
export const getCommentsSuccess = (comments:any) => ({type: REQUEST_COMMENTS_SUCCESS, payload: comments}); 
export const getCommentsError = () => ({type: REQUEST_COMMENTS_ERROR});

/** TAGS */
export const addTagSuccess = (tag:ITag) => ({type: ADD_TAG_SUCCESS, payload:tag}); 
export const addTagError = () => ({type: ADD_TAG_ERROR}); 
export const updateTagSuccess = (tag:ITag) => ({type: UPDATE_TAG_SUCCESS, payload:tag}); 
export const updateTagError = () => ({type: UPDATE_TAG_ERROR}); 
export const removeTagSuccess = (id:string) => ({type: REMOVE_TAG_SUCCESS, payload:id}); 
export const removeTagError = () => ({type: REMOVE_TAG_ERROR}); 
export const getTagSuccess = (tag:ITag) => ({type: REQUEST_TAG_SUCCESS, payload: {tag}}); 
export const getTagError = () => ({type: REQUEST_TAG_ERROR});
export const getTagsSuccess = (tags:any) => ({type: REQUEST_TAGS_SUCCESS, payload: tags}); 
export const getTagsError = () => ({type: REQUEST_TAGS_ERROR});

/** LIKES */
export const likeCountUpdateSuccess = (count:number) => ({type: UPDATE_LIKE_COUNT_SUCCESS, payload: count});
export const likeCountUpdateError = () => ({type: UPDATE_LIKE_COUNT_ERROR});
export const likeSuccess = (data:any) => ({type: UPDATE_LIKE_SUCCESS, payload: data});
export const likeError = () => ({type: UPDATE_LIKE_ERROR});

/** ALERTS */
export const alertUpdateSuccess = (alert:IAlert) => ({type: UPDATE_ALERT_SUCCESS, payload: alert});
export const alertUpdateError = () => ({type: UPDATE_ALERT_ERROR});
export const alertAddSuccess = (alert:IAlert) => ({type: ADD_ALERT_SUCCESS, payload: alert});
export const alertAddError = () => ({type: ADD_ALERT_ERROR});
export const alertRemoveSuccess = (id:string) => ({type: REMOVE_ALERT_SUCCESS, payload: id});
export const alertRemoveError = () => ({type: REMOVE_ALERT_ERROR});
export const getAlertSuccess = (alert:IAlert) => ({type: REQUEST_ALERT_SUCCESS, payload: alert});
export const getAlertError = () => ({type: REQUEST_ALERT_ERROR});
export const getAlertsSuccess = (alerts:any) => ({type: REQUEST_ALERTS_SUCCESS, payload: alerts});
export const getAlertsError = () => ({type: REQUEST_ALERTS_ERROR});

/** Pending Approval Posts */
export const updatePendingPostsError = () => ({type: CHECK_PENDING_POSTS_ERROR});
export const updatePendingPostsSuccess = (posts:any) => ({type: CHECK_PENDING_POSTS_SUCCESS, payload: posts});

/** KEYS */
export const getKeysSuccess = (keys:any) => ({type:REQUEST_KEYS_SUCCESS, payload: keys});
export const getKeysError = () => ({type: REQUEST_KEYS_ERROR});
export const updateKeySuccess = (key:any) => ({type: UPDATE_KEY_SUCCESS, payload: key});
export const updateKeyError = () => ({type: UPDATE_KEY_ERROR});
export const addKeySuccess = (key:any) => ({type: ADD_KEY_SUCCESS, payload: key});
export const addKeyError = () => ({type: ADD_KEY_ERROR});
export const removeKeySuccess = (id:string) => ({type: REMOVE_KEY_SUCCESS, payload: id});
export const removeKeyError = () => ({type: REMOVE_KEY_ERROR});